import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function Datesheet() {
  return (
    <>
      <Header />
      {/* Inner Slider */}
      <section class="inr-header">
        <div class="container">
          <div class="inr-header-content">
            <h1 class="title">Datesheet</h1>
            <ul class="breadcrumb">
              <li><NavLink to="/">Home</NavLink></li>
              <li> Datesheet</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  Inner Body */}
     <section className="innerBody">
  <div className="container them-container">
    <div className="row">
      <div className="col-12">
        <div className="pdf-viewer">
          <iframe
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/pdf/datasheet.pdf"
            title="PDF Viewer"
            width="100%"
            height="800px"
            style={{
              border: "none",
              display: "block",
            }}
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</section>
      <div className="clr100"></div>
      {/* Footer */}
      <Footer />
    </>
  )
}

export default Datesheet